// import $ from 'jquery'
export const index_add = {
  data(){
          //更新内容栏的校验(三选一校验)
  var validateNum = (rule, value, callback) => {
      if (
        !this.form.renew_content &&
        !this.form.privacy_link &&
        !this.form.member_order &&
        !this.form.member_adv &&
        !this.form.centre_sdk_up
      ) {
        callback(new Error("请至少填写一项"));
      } else {
        if (this.form.privacy_link) {
          if(this.form.privacy_link.includes("http") || this.form.privacy_link.includes("https")){
            callback();
          }else{
            return callback(new Error('请检查“隐私政策链接”是否按要求填写'))
          }
        }else{
          callback();
        }
      }
    };
    let checkPrice = (rule,value,callback)=>{
      if(value){
        // let rgx = /^(http|https|ftp):\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/;
        if(value.includes("http") || value.includes("https")){
          callback();
          /*  $.ajax({
            url: value,
            type: 'GET',
            dataType: 'jsonp',
            complete: function (response) {
              console.log(response, 'xx')
              //根据返回的状态码进行判断
              if (response.status == 200) { //正常访问
                callback();
              } else {
                return callback(new Error('该页面无法正常访问，请检查'))
              }
            }
          }); */
        }else{
          return callback(new Error('请检查“隐私政策链接”是否按要求填写'))
        }
      }
    };
      return{
          rules: {
            appid: [{ required: true, message: "应用为必选项", trigger: "blur" }], //应用校验
            version: [
                { required: true, message: "版本号为必填项", trigger: "blur" }, //版本号校验
              ],
              date: [{ required: true, message: "时间为必填项", trigger: "blur" }], //时间校验
              product_admin_id: [
                { required: true, message: "产品负责人为必填项", trigger: "blur" }, //产品负责人校验
              ],
              renew_content: [
                { required: true, validator: validateNum, trigger: "blur" },
                { message: "请至少选填一项", trigger: "blur" },
              ], //产品功能更新校验
/*               privacy_link:[
                { required: true,validator: validateNum, trigger: "blur" },
                {validator:checkPrice,trigger: "blur"},
                { message: "请至少选填一项", trigger: "blur" },
              ], */
              privacy_link: [
                { required: true, validator: validateNum, trigger: "blur" },
                { message: "请至少选填一项", trigger: "blur" },
                // {validator:checkPrice,trigger: "blur"},
              ], //权限隐私更新校验
              member_adv: [
                { required: true, validator: validateNum, trigger: "blur" },
                { message: "请至少选填一项", trigger: "blur" },
              ], //广告更新校验
              member_order: [
                { required: true, validator: validateNum, trigger: "blur" },
                { message: "请至少选填一项", trigger: "blur" },
              ], //会员更新校验
              centre_sdk_up:[{required:true,validator:validateNum,trigger:"blur"},{ message: "五项请至少选填一项", trigger: "blur" }],
            },
      }
  }
}